import { Component, OnInit } from '@angular/core';
import { datosDashboardPublico } from 'src/app/models/datosDashboardPublico';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  public isLoadingResults = true;
  public dataDash: datosDashboardPublico = {
    deportistasActivos: 0,
    deportistasIngresdoMes: 0,
    diasRestantesServicio: 0,
    fechaServicioHasta: '',
    ingresosHoy: 0,
    ingresosTotales: 0,
    ordenesCompraPendientes: 0,
    saldo: 0,
  };

  datosGrafica: any;
  constructor(private dashSvc: DashboardService) {}

  ngOnInit(): void {
    this.dashSvc
      .getDatosPublicos()
      .subscribe((result: datosDashboardPublico) => {
        console.log(result);
        this.dataDash = result;
        this.isLoadingResults=false;
      });

    this.dashSvc.getGraficaIngresoUltimos20Dias().subscribe((result) => {
      console.log('data grafica:', result);
      this.datosGrafica = result;
    });
  }
}
